import { callRpc, handleOperationError } from './supabase-operations.js';

/**
 * Activity tracking service for recording user interactions with records.
 * Tracks page views and other user activities for analytics and audit purposes.
 */
class ActivityTracker {
  private trackingEnabled: boolean;

  constructor() {
    this.trackingEnabled = true;
  }

  /**
   * Tracks when a user views a specific record
   * @param tableName - The name of the table containing the record
   * @param recordId - The ID of the record being viewed
   * @param recordDisplayName - Optional display name for the record
   */
  async trackUserView(
    tableName: string, 
    recordId: number | string, 
    recordDisplayName: string | null = null
  ): Promise<void> {
    if (!this.trackingEnabled) return;
    
    try {
      await callRpc({
        schema: 'core_crm',
        functionName: 'track_user_view',
        params: {
          p_table_name: tableName,
          p_record_id: recordId.toString(),
          p_record_display_name: recordDisplayName
        }
      });
    } catch (err) {
      const errorInfo = handleOperationError(err, 'Failed to track user view');
      console.warn('Activity tracking error:', errorInfo.debugInfo);
    }
  }

  /**
   * Disables activity tracking
   */
  disable(): void {
    this.trackingEnabled = false;
  }

  /**
   * Enables activity tracking
   */
  enable(): void {
    this.trackingEnabled = true;
  }

  /**
   * Gets current tracking status
   */
  isEnabled(): boolean {
    return this.trackingEnabled;
  }
}

export const activityTracker = new ActivityTracker();